module.exports = __webpack_public_path__ + "img/reward_5.218c5d04.png";